



































import { computed, defineComponent, Ref, ref } from '@vue/composition-api';
import { useGlobals }                          from '@/hooks/use-globals';
import { Season }                              from '@/views/seasons/seasons.types';
import { Computed }                            from '@/types';
import cRadioButton                            from '@/components/form/radio-button/radio-button.component.vue';
import cIconEdit                               from '@/components/icons/icon-edit.component.vue';
import cPlusButton                             from '@/components/custom/buttons/plus-button/plus-button.component.vue';
import cRadioGroup                             from '@/components/form/radio-group/radio-group.component.vue';
import { changeColorInHex }                    from '@/styles/variables.helpers';
import cAddSeason                              from './add-season.component.vue';


export default defineComponent({
  name: 'cSeasonsList',
  components: {
    cRadioGroup,
    cRadioButton,
    cIconEdit,
    cPlusButton,
    cAddSeason,
  },
  setup() {
    const { store, i18n } = useGlobals();
    const selectedSeason: Ref<Season> = ref({});
    const seasonList: Ref<HTMLElement | null> = ref(null);
    const radioValue: Ref<string> = ref('');
    const seasons: Computed<Season[]> = computed((): Season[] => store.state.views.vSeasons.seasons);
    const isModalOpen: Computed<boolean> = computed((): boolean => store.state.views.vSeasons.modal.open);
    const setRadioValue = (event: string) => {
      radioValue.value = event;
    };

    const setCssVariable = (color: string): void => {
      if (seasonList.value) {
        seasonList.value.style.setProperty('--season-color', changeColorInHex(color, 30, false));
      }
    };

    const toggleSidePanel = (payload: boolean): void => {
      store.commit('views/vSeasons/toggleModal', payload);
      selectedSeason.value = { name: '', code: '', color: '' };
      radioValue.value = '';
      store.commit('views/vSeasons/updateSelection', { seasonCode: null });
    };

    const addSeason = (): void => {
      selectedSeason.value = { name: '', code: '', color: '', order: seasons.value.length };
      store.commit('views/vSeasons/setFields', selectedSeason.value);
      store.commit('views/vSeasons/setModalMode', 'CREATE');
      toggleSidePanel(true);
    };

    const editSeason = (season: Season): void => {
      store.commit('views/vSeasons/setFields', season);
      store.commit('views/vSeasons/setModalMode', 'EDIT');
      toggleSidePanel(true);
    };

    const selectSeason = (season: Season): void => {
      selectedSeason.value = season;
      setCssVariable(season.color);
      store.commit('views/vSeasons/setSeasonCode', season.code);
    };

    return {
      i18n,
      seasons,
      selectedSeason,
      seasonList,
      radioValue,
      isModalOpen,
      addSeason,
      editSeason,
      toggleSidePanel,
      selectSeason,
      setRadioValue,
    };
  },
});
